import type { ReactElement } from 'react';
import { useGamesSite } from '../context';
import { Breadcrumbs } from '../components/PublicSiteFrame';
import { GameRow } from '../components/GameRow';
import { gameCount } from '../format';
import { GAMES_HOME_PATH } from '../routes';
import type { GameArchePageData } from '../types';

/** Every game in one arche (`/a/games/from/<key>`), with a way into the arche itself. */
export function ArcheGamesBody({ data }: { data: GameArchePageData }): ReactElement {
  const { Link } = useGamesSite();
  const { arche, games, total } = data;
  return (
    <div className="fg-wrap">
      <Breadcrumbs trail={[{ label: 'Games', href: GAMES_HOME_PATH }, { label: arche.name }]} />
      <header className="fg-banner fg-banner--arche">
        <h1 className="fg-banner__title">Games in {arche.name}</h1>
        <p className="fg-banner__count">{gameCount(total)}</p>
        <Link href={arche.launchPath} className="fg-banner__open">
          Open {arche.name}
        </Link>
      </header>
      <ul className="fg-list">
        {games.map((game) => (
          <li key={game.slug}>
            <GameRow game={game} iconSize="md" headingLevel={2} />
          </li>
        ))}
      </ul>
    </div>
  );
}
